import { render, staticRenderFns } from "./PillarItem.vue?vue&type=template&id=4a349a52&scoped=true&"
import script from "./PillarItem.vue?vue&type=script&lang=js&"
export * from "./PillarItem.vue?vue&type=script&lang=js&"
import style0 from "./PillarItem.vue?vue&type=style&index=0&id=4a349a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a349a52",
  null
  
)

export default component.exports